bin.classy.controller({
    name: "QuickAwardController",
    inject: [
        "$scope", "$sce", "$timeout", "$location", "$modalInstance", "$anchorScroll", "accounts", "app", "budgets",
        "authServiceFactory", "BinFactory", "SchoolSubcategoriesModelService", "ApplicationService",
        "BudgetsModelService", "AppModelService", "AccountModelService", "BinService", "DetermineAwardService",
        "SchoolModelService", "PermissionModelService"
    ],
    init: function() {
        this.$.active = "award";
        this.$.budgets = this.budgets.data;
        this.$.accounts = this.accounts[0].data;
        this.$.app = this.app;
        this.$.$modalInstance = this.$modalInstance;
        this.$.budgetPutObject = [];
        this.buildBudgetPutObject();
        this.$.schoolinfo = this.SchoolModelService.get()[0];
    },
    getField: function(item, field) {
        if (item["x" + field] === null || item[field] === item["x" + field]) {
            return item[field];
        } else {
            return item["x" + field];
        }
    },
    buildPutObject: function(app) {
        let obj = [];
        this.$.putObject = {type: "Award", Rec_Aw: 0, applicants: []};

        for (let i = 0; i < app.Applicants.length; i++) {
            obj[i] = {recordID: "", App_Tuition: "", Act_Award: ""};
            obj[i].recordID = app.ApplicantIDs[i];
            obj[i].App_Tuition = parseInt(app.Tuitions[i]);
            if (this.$.schoolinfo.Award_Pref_1 === 1) {
                if (app.ConsiderAwards === undefined) {
                    obj[i].Act_Award = parseInt(app.Tuitions[i]);
                } else {
                    obj[i].Act_Award = parseInt(app.Tuitions[i]) - parseInt(app.ConsiderAwards[i]);
                }
            } else {
                if (app.ConsiderAwards === undefined) {
                    obj[i].Act_Award = 0;
                } else {
                    obj[i].Act_Award = parseInt(app.ConsiderAwards[i]) || 0;
                }
            }
            this.$.sum += obj[i].Act_Award;
        }

        this.$.putObject.applicants = obj;
        return this.$.putObject;
    },
    awardApplicant: function(scope, instance, form, app) {
        this.$.sum = 0;
        this.AppModelService.AwardApplicant(app.applicationID, this.buildPutObject(app)).then(() => {
            this.BinFactory.retrieveData();
            let data = {
                Status_New: 0,
                Status_Viewed: 0,
                Status_Consider: 0,
                Status_Award: 1,
                Status_Reject: 0,
                Status_Unfinished: 0
            };
            this.AppModelService.put(app.applicationID, data);
            let flag = true;
            if (this.AccountModelService.get().accounts.length > 0) {
                for (let i = 0; i < this.AccountModelService.get().accounts.length; i++) {
                    if (this.AccountModelService.get().accounts[i].Active === 1 && this.$.sum !== 0) {
                        this.setBudget(scope,instance,form);
                    } else {
                        flag = false;
                    }
                    break;
                }
                if (flag === false) {
                    this.DetermineAwardService.setAwardComplete("Award");
                }
            } else {
                this.DetermineAwardService.setAwardComplete("Award");
            }
        }).then(() => {
            this.$.$modalInstance.dismiss("cancel");
        });
    },
    setReject: function(app) {
        //Move to reject bin
        let putObject = {type: "Reject", applicants: []};
        this.buildBudgetPutObject(app.applicants);
        for (let i = 0; i < app.applicants.length; i++) {
            putObject.applicants[i].Act_Award = 0;
        }
        putObject.type = "Reject";
        this.AppModelService.AwardApplicant(this.$.app.applicationID, putObject).then(() => {
            this.DetermineAwardService.setAwardComplete("Reject");

            // set budgets to 0 for rejection
            for (let i in this.$.budgetPutObject) { // for each applicant
                for (let j in this.$.budgetPutObject[i]) { // for each budget
                    this.$.budgetPutObject[i][j].award = 0;
                }
            }
            this.setBudget();
        });
    },
    buildBudgetPutObject: function() {
        // Build out budgetPutObject per applicant
        for (let i = 0; i < this.$.app.Applicants.length; i++) {
            this.$.budgetPutObject[i] = [];
        }
        // Build budgetPutObject from existing budget records
        for (let i = 0; i < this.$.budgets.length; i++) {
            let accountID = this.$.budgets[i].accountID;
            let index = this.$.app.ApplicantIDs.indexOf(String(this.$.budgets[i].applicantID));
            this.$.budgetPutObject[index][accountID] = {
                schoolID: this.$.budgets[i].schoolID,
                applicationID: this.$.budgets[i].applicationID,
                recordID: this.$.budgets[i].recordID,
                accountID: this.$.budgets[i].accountID,
                award: this.$.budgets[i].award,
                applicantID: this.$.budgets[i].applicantID
            };
        }
        // Check to see if any are missing and fill them in
        for (let j = 0; j < this.$.app.Applicants.length; j++) {
            for (let k = 0; k < this.$.accounts.accounts.length; k++) {
                let accountID = this.$.accounts.accounts[k].recordID;
                if (this.$.budgetPutObject[j][accountID] === undefined) {
                    this.$.budgetPutObject[j][accountID] = {
                        schoolID: this.$.accounts.accounts[k].schoolID,
                        applicationID: this.$.app.applicationID,
                        accountID: this.$.accounts.accounts[k].recordID,
                        award: 0,
                        applicantID: this.$.app.ApplicantIDs[j]
                    };
                }
            }
        }
    },
    setBudget: function(scope, instance) {
        // compress array
        let compressedBudgets = [];
        instance.options.factor  = .5;
        for (let i in this.$.budgetPutObject) {
            for (let j in this.$.budgetPutObject[i]) {
                compressedBudgets.push(this.$.budgetPutObject[i][j]);
            }
        }
        this.BudgetsModelService.put(this.$.app.applicationID, compressedBudgets).then(() => {
            this.BudgetsModelService.getFromApp(this.$.app.applicationID).then((data) => {
                // copy recordID's to putobject for budgets that just got inserted
                for (let i in data.data) {
                    for (let j in this.$.budgetPutObject) { // j is applicant index
                        let id = this.$.budgetPutObject[j][data.data[i].accountID].applicantID;
                        if (data.data[i].applicantID === id) {
                            this.$.budgetPutObject[j][data.data[i].accountID].recordID = data.data[i].recordID;
                        }
                    }
                }
            });
            this.DetermineAwardService.setAwardComplete("Award");
            this.$.$modalInstance.dismiss("cancel");
        });
    },
    successSave: function(scope) {
        this.$.$modalInstance.dismiss("cancel");
    }
});
